module.exports = __webpack_public_path__ + "static/img/10.8fcbf52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/10.png
// module id = eCqB
// module chunks = 0